import { UserAvatar } from "components/Atoms/Avatar";
import BrandLogo from "components/BrandLogo";
import React from "react";
import { Message } from "components/Atoms/Message";
import { useLoaderData } from "react-router";
import Table from "components/Tables/Table";
import { ButtonPrimary } from "components/Atoms/Button";

const App = () => {
  const viewModel = useLoaderData<server.viewmodel.PublicEmailDownloadFrontModel>();

  return <div className="s1_main-panel small">
    <div className="content-section flex-column gap-big">
      <BrandLogo brand={viewModel.brand} boxWhenNoImage />
      {viewModel.errorMessage ? <Message type="error">
        {viewModel.errorMessage}
      </Message> : <>
        <div className="flex gap align-center justify-center">
          <UserAvatar user={viewModel.emailMessage.sendBy} />
          {`${viewModel.emailMessage.sendBy.fullName} shared files`}
        </div>

        <Table
          items={viewModel.emailMessage.attachments}
          isLoading={false}
          getKey={file => `${file.id}`}
          columns={[{
            key: "fileName",
            header: RESX.File.Files,
            render: file => <div>{file.fullName}</div>,
            size: "1fr",
          }, {
            key: "fileSize",
            header: "",
            render: file => <div>{file.contentLengthText}</div>,
          }]}
        />

        <div className="flex justify-end">
          <ButtonPrimary
            label={RESX.File.DownloadAll}
            href={viewModel.downloadFilesArchiveLink}
          />
        </div>
      </>}
    </div>
  </div>
}

export default App;